// aws-sdk requires global to exist
(window as any).global = window;

import { createApp } from "vue";
import App from "./App.vue";
import "./style.css";

import * as Sentry from "@sentry/vue";

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://666bf83e4f80e880ceed76a6c724fbcd@o28781.ingest.us.sentry.io/4511196121923584",
  enabled: import.meta.env.PROD,
  sendDefaultPii: true,
  tunnel: "https://etun.pacsbin.com",
  beforeBreadcrumb(crumb) {
    // Drop [ProgressEvent] XHR console errors that flood breadcrumbs without diagnostic value
    if (crumb.category === 'console' && typeof crumb.message === 'string'
        && crumb.message.includes('[ProgressEvent]')) return null;
    return crumb;
  },
});

window.addEventListener('error', (ev) => {
  Sentry.captureException(ev.error ?? new Error(ev.message), {
    tags: { source: 'global-error' },
    extra: { filename: ev.filename, lineno: ev.lineno, colno: ev.colno },
  });
});

window.addEventListener('unhandledrejection', (ev) => {
  Sentry.captureException(ev.reason, { tags: { source: 'unhandledrejection' } });
});

app.mount("#app");
